(() => {
  if (window.__elementKlaviyoCart) return;
  window.__elementKlaviyoCart = true;

  let pending = 0;

  const trackAddedToCart = async () => {
    window.clearTimeout(pending);
    pending = window.setTimeout(async () => {
      try {
        const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => {
          if (!response.ok) throw new Error('cart');
          return response.json();
        });
        const item = Array.isArray(cart.items) ? cart.items[0] : null;
        const payload = {
          $value: (cart.total_price || 0) / 100,
          total_price: (cart.total_price || 0) / 100,
          total_discount: cart.total_discount,
          original_total_price: (cart.original_total_price || 0) / 100,
          items: cart.items
        };
        if (item) {
          payload.Name = item.product_title;
          payload.ProductID = item.product_id;
          payload.SKU = item.sku;
          payload.ImageURL = item.image;
          payload.URL = `${window.location.origin}${item.url || ''}`;
          payload.Brand = item.vendor;
          payload.Price = (item.final_price || item.price || 0) / 100;
          payload.CompareAtPrice = (item.original_price || 0) / 100;
        }

        const klaviyo = window.klaviyo;
        if (klaviyo && typeof klaviyo.track === 'function') {
          klaviyo.track('Added to Cart', payload);
          return;
        }
        (window.klaviyo = window.klaviyo || []).push(['track', 'Added to Cart', payload]);
        (window._learnq = window._learnq || []).push(['track', 'Added to Cart', payload]);
      } catch (error) {}
    }, 200);
  };

  const isCartAdd = (value) => /\/cart\/add(\.js)?(\?|$)/.test(String(value || ''));

  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const request = args[0];
    const url = typeof request === 'string' ? request : request?.url;
    return originalFetch.apply(this, args).then((response) => {
      if (response.ok && (isCartAdd(url) || isCartAdd(response.url))) {
        trackAddedToCart();
      }
      return response;
    });
  };

  document.addEventListener('element:cart-added', trackAddedToCart);
})();
